import editorConfig from './editorConfig'

import ListDefault from './editorjs/list'

/**
 * Создает кнопку отправки с иконкой
 * @param {string} classes - классы для кнопки. Пишутся через пробел.
 * @param {object} - объект с настройками кнопки
 * @param {string} textContent - дополнительная подпись к кнопке
 * @param {boolean} disableIcon - отключает иконку если true
 * @param {string} type - тип кнопки
 *
 * @return {HTMLButtonElement} - возвращает DOM-узел созданной кнопки
 */
function createButton (classes, { textContent = '', disableIcon = false, type = 'button' } = {}) {
  const btn = document.createElement('button'),
    icon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#afafaf" d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
  if (classes) btn.classList.add(...classes.split(' '), 'btn-redactor')
  btn.setAttribute('type', type)
  btn.innerHTML = `<span>${textContent}</span> ${disableIcon ? '' : icon}`
  return btn
}

function createInputFiles() {
  const input = document.createElement('input')
  input.type = 'file'
  input.name = 'pictures[]'
  input.multiple = true
  return input
}

export class List extends ListDefault {
  validate (savedData) {
    return !!(savedData && savedData.items.length && savedData.style != null)
  }
}

export class Unsplash {
  static get toolbox () {
    return {
      title: 'Фото из галереи Unsplash',
      icon: '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/image/small" stroke="none" stroke-width="1"><path d="M12.3863,1.25 C13.6373213,1.25 14.6613804,2.2219332 14.7445468,3.4518691 L14.75,3.6137 L14.75,12.3863 C14.75,13.6373213 13.7780668,14.6613804 12.5481309,14.7445468 L12.3863,14.75 L3.6137,14.75 C2.36267867,14.75 1.33861958,13.7780668 1.25545323,12.5481309 L1.25,12.3863 L1.25,3.6137 C1.25,2.36267867 2.2219332,1.33861958 3.4518691,1.25545323 L3.6137,1.25 L12.3863,1.25 Z M12.3863,2.75 L3.6137,2.75 C3.17340483,2.75 2.81002855,3.07950741 2.75672981,3.50536361 L2.75,3.6137 L2.75,12.3863 C2.75,12.8265952 3.07950741,13.1899714 3.50536361,13.2432702 L3.6137,13.25 L5.597,13.25 L9.37596228,7.58397485 C9.56479233,7.30072978 9.91684973,7.183926 10.2320011,7.28671182 L10.3354102,7.32917961 L13.25,8.787 L13.25,3.6137 C13.25,3.17340483 12.9204926,2.81002855 12.4946364,2.75672981 L12.3863,2.75 Z M10.257,8.967 L7.401,13.25 L12.3863,13.25 C12.8265952,13.25 13.1899714,12.9204926 13.2432702,12.4946364 L13.25,12.3863 L13.25,10.463 L10.257,8.967 Z M6,4 C7.1046,4 8,4.8954 8,6 C8,7.1046 7.1046,8 6,8 C4.8954,8 4,7.1046 4,6 C4,4.8954 4.8954,4 6,4 Z" id="Combined-Shape"></path></g></svg>',
    }
  }

  constructor ({ data }) {
    this.data = data
    this.wrapper = undefined
  }

  render () {
    this.wrapper = document.createElement('div')
    this.wrapper.classList.add('unsplash')
    if (this.data.url != null) {
      this.wrapper.innerHTML = `<img src="${this.data.url}" alt="${this.data.alt}"/>`
      this.wrapper.classList.add('unsplash-grid--passed')
    } else {
      this.wrapper.innerHTML = `
        <span>Введите ключевое слово для поиска фотографии в галерее Unsplash:</span>
        <input type="text" class="unsplash_input" placeholder="Пример: Стройка" />
      `
      const button = createButton('unsplash_button', { textContent: 'Найти' }),
        input = this.wrapper.querySelector('.unsplash_input')

      button.setAttribute('type', 'button')
      this.wrapper.appendChild(button)

      button.addEventListener('click', e => {
        button.innerHTML = '<div class="preloader"></div>'
        this._createImg(input.value)
      })
    }

    return this.wrapper
  }

  _createImg (keyword) {
    fetch(`http://support.data.ms.bimlib.ru:8036/?page=1&query=${keyword}`, { method: 'GET' })
      .then(res => res.json())
      .then(response => this._createGrid(response))
      .catch(err => { throw err })
  }

  _createGrid (images) {
    this.wrapper.innerHTML = 'Выбери фотографию:'
    const grid = document.createElement('div')
    grid.classList.add('unsplash-grid')
    this.wrapper.appendChild(grid)
    images.forEach(el => { grid.innerHTML += `<img class="unsplash-grid_img" style="max-width: 100%" alt="${el.alt_description}" src="${el.small}">` })

    grid.addEventListener('click', function (event) {
      const target = event.target
      if (target.hasAttribute('alt')) {
        const wrapper = document.querySelector('.unsplash')
        wrapper.innerHTML = ''
        wrapper.appendChild(target)
        wrapper.classList.add('unsplash-grid--passed')
      }
    })
  }

  save (blockContent) {
    const unsplashImage = blockContent.querySelector('.unsplash-grid_img')
    if (unsplashImage) {
      return {
        url: unsplashImage.src,
        alt: unsplashImage.alt,
      }
    }
  }

  validate (savedData) {
    return !!(savedData && savedData.url != null)
  }
}

export class BlockHr {
  static get toolbox () {
    return {
      title: 'Добавить hr',
      icon:
        '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/hr/small" stroke="none" stroke-width="1"><path d="M14,10.25 C14.3796958,10.25 14.693491,10.5321539 14.7431534,10.8982294 L14.75,11 L14.75,14 C14.75,14.4142136 14.4142136,14.75 14,14.75 C13.6203042,14.75 13.306509,14.4678461 13.2568466,14.1017706 L13.25,14 L13.25,11.75 L2.75,11.75 L2.75,14 C2.75,14.3796958 2.46784612,14.693491 2.10177056,14.7431534 L2,14.75 C1.62030423,14.75 1.30650904,14.4678461 1.25684662,14.1017706 L1.25,14 L1.25,11 C1.25,10.6203042 1.53215388,10.306509 1.89822944,10.2568466 L2,10.25 L14,10.25 Z M8,7 C8.5523,7 9,7.4477 9,8 C9,8.5523 8.5523,9 8,9 C7.4477,9 7,8.5523 7,8 C7,7.4477 7.4477,7 8,7 Z M14,7.25 C14.4142136,7.25 14.75,7.58578644 14.75,8 C14.75,8.37969577 14.4678461,8.69349096 14.1017706,8.74315338 L14,8.75 L11,8.75 C10.5857864,8.75 10.25,8.41421356 10.25,8 C10.25,7.62030423 10.5321539,7.30650904 10.8982294,7.25684662 L11,7.25 L14,7.25 Z M5,7.25 C5.41421356,7.25 5.75,7.58578644 5.75,8 C5.75,8.37969577 5.46784612,8.69349096 5.10177056,8.74315338 L5,8.75 L2,8.75 C1.58578644,8.75 1.25,8.41421356 1.25,8 C1.25,7.62030423 1.53215388,7.30650904 1.89822944,7.25684662 L2,7.25 L5,7.25 Z M14,1.25 C14.3796958,1.25 14.693491,1.53215388 14.7431534,1.89822944 L14.75,2 L14.75,5 C14.75,5.37969577 14.4678461,5.69349096 14.1017706,5.74315338 L14,5.75 L2,5.75 C1.62030423,5.75 1.30650904,5.46784612 1.25684662,5.10177056 L1.25,5 L1.25,2 C1.25,1.58578644 1.58578644,1.25 2,1.25 C2.37969577,1.25 2.69349096,1.53215388 2.74315338,1.89822944 L2.75,2 L2.75,4.25 L13.25,4.25 L13.25,2 C13.25,1.62030423 13.5321539,1.30650904 13.8982294,1.25684662 L14,1.25 Z" id="hr"></path></g></svg>',
    }
  }

  render () {
    const template = '<div class="wrapper-hr"><hr/></div>',
      div = document.createElement('div')
    div.innerHTML = template.trim()

    return div
  }

  save () {
    return { blockType: 'hr' }
  }
}

export class TextGrid {
  static get toolbox () {
    return {
      title: 'Текст по колонкам',
      icon:
        '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/textColumn/small" stroke="none" stroke-width="1"><path d="M4.5,12 C4.91421356,12 5.25,12.3357864 5.25,12.75 C5.25,13.1296958 4.96784612,13.443491 4.60177056,13.4931534 L4.5,13.5 L2.5,13.5 C2.08578644,13.5 1.75,13.1642136 1.75,12.75 C1.75,12.3703042 2.03215388,12.056509 2.39822944,12.0068466 L2.5,12 L4.5,12 Z M11.5,12 C11.9142136,12 12.25,12.3357864 12.25,12.75 C12.25,13.1296958 11.9678461,13.443491 11.6017706,13.4931534 L11.5,13.5 L9.5,13.5 C9.08578644,13.5 8.75,13.1642136 8.75,12.75 C8.75,12.3703042 9.03215388,12.056509 9.39822944,12.0068466 L9.5,12 L11.5,12 Z M6.5,9 C6.91421356,9 7.25,9.33578644 7.25,9.75 C7.25,10.1296958 6.96784612,10.443491 6.60177056,10.4931534 L6.5,10.5 L2.5,10.5 C2.08578644,10.5 1.75,10.1642136 1.75,9.75 C1.75,9.37030423 2.03215388,9.05650904 2.39822944,9.00684662 L2.5,9 L6.5,9 Z M13.5,9 C13.9142136,9 14.25,9.33578644 14.25,9.75 C14.25,10.1296958 13.9678461,10.443491 13.6017706,10.4931534 L13.5,10.5 L9.5,10.5 C9.08578644,10.5 8.75,10.1642136 8.75,9.75 C8.75,9.37030423 9.03215388,9.05650904 9.39822944,9.00684662 L9.5,9 L13.5,9 Z M6.5,6 C6.91421356,6 7.25,6.33578644 7.25,6.75 C7.25,7.12969577 6.96784612,7.44349096 6.60177056,7.49315338 L6.5,7.5 L2.5,7.5 C2.08578644,7.5 1.75,7.16421356 1.75,6.75 C1.75,6.37030423 2.03215388,6.05650904 2.39822944,6.00684662 L2.5,6 L6.5,6 Z M11.5,6 C11.9142136,6 12.25,6.33578644 12.25,6.75 C12.25,7.12969577 11.9678461,7.44349096 11.6017706,7.49315338 L11.5,7.5 L9.5,7.5 C9.08578644,7.5 8.75,7.16421356 8.75,6.75 C8.75,6.37030423 9.03215388,6.05650904 9.39822944,6.00684662 L9.5,6 L11.5,6 Z M4.5,3 C4.91421356,3 5.25,3.33578644 5.25,3.75 C5.25,4.12969577 4.96784612,4.44349096 4.60177056,4.49315338 L4.5,4.5 L2.5,4.5 C2.08578644,4.5 1.75,4.16421356 1.75,3.75 C1.75,3.37030423 2.03215388,3.05650904 2.39822944,3.00684662 L2.5,3 L4.5,3 Z M13.5,3 C13.9142136,3 14.25,3.33578644 14.25,3.75 C14.25,4.12969577 13.9678461,4.44349096 13.6017706,4.49315338 L13.5,4.5 L9.5,4.5 C9.08578644,4.5 8.75,4.16421356 8.75,3.75 C8.75,3.37030423 9.03215388,3.05650904 9.39822944,3.00684662 L9.5,3 L13.5,3 Z" id="textColumn"></path></g></svg>',
    }
  }

  static get enableLineBreaks () {
    return true
  }

  constructor ({ data }) {
    this.data = data
    this.gridType = null
    this.wrapper = undefined
  }

  render () {
    this.wrapper = document.createElement('div')
    this.wrapper.classList.add('text-grid')

    if (this.data.blocks) {
      this.wrapper.classList.add(`text-grid--${this.data.type}`)
      this.gridType = this.data.type
      this.data.blocks.forEach(el => {
        this.wrapper.innerHTML += `<p contentEditable="true" class="text-grid_paragraph">${el}</p>`
      })
    } else {
      this.wrapper.innerHTML =
        `<select class="text-grid_select">
          <option>6/6</option>
          <option>4/4/4</option>
          <option>3/3/3/3</option>
          <option>8/4</option>
          <option>4/8</option>
          <option>6/3/3</option>
          <option>3/3/6</option>
          <option>2/8/2</option>
        </select>`
      const buttonSubmit = createButton('text-grid_button')
      this.wrapper.appendChild(buttonSubmit)

      buttonSubmit.addEventListener('click', e => {
        this._inputContent()
      })
    }

    return this.wrapper
  }

  _inputContent () {
    const select = this.wrapper.querySelector('.text-grid_select'),
      grid = select.value.split('/'),
      wrapper = `<div class="text-grid_wrap" data="${grid.join('-')}">`,
      gridBody = grid.map(gridCol => `<div class="text-grid_column text-grid_paragraph col-${gridCol}"><div contentEditable="true" class="text-grid_textarea"></div></div>`).join('')

    this.gridType = grid.join('-')
    this.wrapper.classList.add('text-grid--end')
    this.wrapper.innerHTML = wrapper + gridBody + '</div>'
  }

  save (blockContent) {
    if (this.gridType) {
      const gridArray = blockContent.querySelectorAll('.text-grid_paragraph')
      const gridArrayContent = []
      for (let i = 0; i < gridArray.length; i++) {
        gridArrayContent.push(gridArray[i].innerHTML)
      }
      return {
        type: this.gridType,
        blocks: gridArrayContent,
      }
    }
  }

  validate (savedData) {
    if (savedData) {
      for (let i = 0; i < savedData.blocks.length; i++) {
        if (savedData.blocks[i] === '') return false
      }
    }
    return !!(savedData && savedData.blocks != null && savedData.type != null)
  }
}

export class Video {
  static get toolbox () {
    return {
      title: 'Video',
      icon: '<svg width="17" height="15" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M176.792,0H59.208C26.561,0,0,26.561,0,59.208v117.584C0,209.439,26.561,236,59.208,236h117.584 C209.439,236,236,209.439,236,176.792V59.208C236,26.561,209.439,0,176.792,0z M196,176.792c0,10.591-8.617,19.208-19.208,19.208 H59.208C48.617,196,40,187.383,40,176.792V59.208C40,48.617,48.617,40,59.208,40h117.584C187.383,40,196,48.617,196,59.208 V176.792z"/></g></g><g><g><path d="M452,0H336c-33.084,0-60,26.916-60,60v116c0,33.084,26.916,60,60,60h116c33.084,0,60-26.916,60-60V60 C512,26.916,485.084,0,452,0z M472,176c0,11.028-8.972,20-20,20H336c-11.028,0-20-8.972-20-20V60c0-11.028,8.972-20,20-20h116 c11.028,0,20,8.972,20,20V176z"/></g></g><g><g><path d="M176.792,276H59.208C26.561,276,0,302.561,0,335.208v117.584C0,485.439,26.561,512,59.208,512h117.584 C209.439,512,236,485.439,236,452.792V335.208C236,302.561,209.439,276,176.792,276z M196,452.792 c0,10.591-8.617,19.208-19.208,19.208H59.208C48.617,472,40,463.383,40,452.792V335.208C40,324.617,48.617,316,59.208,316h117.584 c10.591,0,19.208,8.617,19.208,19.208V452.792z"/></g></g><g><g><path d="M452,276H336c-33.084,0-60,26.916-60,60v116c0,33.084,26.916,60,60,60h116c33.084,0,60-26.916,60-60V336 C512,302.916,485.084,276,452,276z M472,452c0,11.028-8.972,20-20,20H336c-11.028,0-20-8.972-20-20V336c0-11.028,8.972-20,20-20 h116c11.028,0,20,8.972,20,20V452z"/></g></g></svg>',
    }
  }

  constructor ({ data }) {
    this.data = data
    this.wrapper = undefined
  }

  render () {
    this.wrapper = document.createElement('div')
    const videoInput = document.createElement('input')
    videoInput.setAttribute('type', 'text')
    videoInput.classList.add('.video_input')
    this.wrapper.appendChild(videoInput)
    videoInput.addEventListener('change', (e) => {
      this.wrapper.innerHTML = `<vue-plyr><div class="plyr__video-embed"><iframe width="560" height="315" src="${event.target.value}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></vue-plyr>`
    })

    return this.wrapper
  }

  save (blockContent) {
    return {
      videoBlock: this.wrapper.innerHTML.toString(),
    }
  }
}

export class ImageSlider {
  static get toolbox () {
    return {
      title: 'Слайдер картинок',
      icon:
        '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/slider/small" stroke="none" stroke-width="1"><path d="M4,11.5 C4.828,11.5 5.5,12.1716 5.5,13 C5.5,13.8284 4.828,14.5 4,14.5 C3.172,14.5 2.5,13.8284 2.5,13 C2.5,12.1716 3.172,11.5 4,11.5 Z M8,11.5 C8.828,11.5 9.5,12.1716 9.5,13 C9.5,13.8284 8.828,14.5 8,14.5 C7.172,14.5 6.5,13.8284 6.5,13 C6.5,12.1716 7.172,11.5 8,11.5 Z M12,11.5 C12.828,11.5 13.5,12.1716 13.5,13 C13.5,13.8284 12.828,14.5 12,14.5 C11.172,14.5 10.5,13.8284 10.5,13 C10.5,12.1716 11.172,11.5 12,11.5 Z M13.5,1.75 C13.9142136,1.75 14.25,2.08578644 14.25,2.5 L14.25,2.5 L14.25,9.5 C14.25,9.91421356 13.9142136,10.25 13.5,10.25 L13.5,10.25 L2.5,10.25 C2.08578644,10.25 1.75,9.91421356 1.75,9.5 L1.75,9.5 L1.75,2.5 C1.75,2.08578644 2.08578644,1.75 2.5,1.75 L2.5,1.75 Z M12.75,3.25 L3.25,3.25 L3.25,8.75 L12.75,8.75 L12.75,3.25 Z" id="slider"></path></g></svg>',
    }
  }

  constructor ({ data, api }) {
    this.data = data
    this.api = api
    this.wrapper = undefined
  }

  render () {
    this.wrapper = document.createElement('div')
    this.wrapper.classList.add('slider_wrap')

    if (this.data.url != null && this.data.url.length) {

      const list = this._createElementsSlider(this.data.url)

      this.data.url.forEach(img => {
        list.innerHTML +=
        `<li>
            <img class="slider_img editor-img" src="/uploads${img.url}" alt=${img.alt}>
            <span class="slider_caption editor-img_caption">${img.cap}</span>
        </li>`
      })

    } else {
      const buttonSubmit = createButton()
      const input = createInputFiles()

      this.wrapper.appendChild(input)
      this.wrapper.appendChild(buttonSubmit)

      buttonSubmit.addEventListener('click', e => {
        if (input.files.length > 2) {
          const payload = new FormData();

          Array.from(input.files).forEach(img => payload.append('pictures[]', img))

          fetch(editorConfig.imgUploadURL, {
            method: 'POST',
            body: payload,
          })
            .then(res => res.json())
            .then(response => {
              this._createSlider(response)
            })
            .catch(console.error)
        } else {
          window.$toast('Для создания слайдера требуется минимум 3 изображения!', { title: 'Ошибка... :(' })
        }
      })
    }

    return this.wrapper
  }

  _createElementsSlider (url) {
    const arrowLeft = document.createElement('div')
    arrowLeft.classList.add('slider_switch', 'slider_switch--left')

    const sliderList = document.createElement('ul')
    sliderList.classList.add('slider_list')

    const arrowRight = document.createElement('div')
    arrowRight.classList.add('slider_switch', 'slider_switch--right')
    this.wrapper.innerHTML = ''
    this.wrapper.appendChild(sliderList)
    this.wrapper.appendChild(arrowLeft)
    this.wrapper.appendChild(arrowRight)

    sliderList.style.left = '0'
    let position = parseInt(sliderList.style.left, 10)

    arrowLeft.addEventListener('click', () => {
      if (position !== 0) {
        position += 100
        sliderList.style.left = position + '%'
      }
    })

    const sliderArrayL = (url.length - 1) * -100

    arrowRight.addEventListener('click', () => {
      if (position !== sliderArrayL) {
        position -= 100
        sliderList.style.left = position + '%'
      }
    })
    return sliderList
  }

  _createSlider (url) {
    this.wrapper.classList.add('slider_wrap--edit')
    const list = this._createElementsSlider(url)

    url.forEach((img, idx) => {
      list.innerHTML +=
      `<li>
        <img data-image="${idx}" alt="image-${idx}" class="image-grid_img editor-img" src="/uploads${img.url}">
        <div class="form">
          <label>Комментарий<input data-image="${idx}" class="image-grid_caption-input editor-img_caption" type="text" ></label>
          <label>Alt<input data-image="${idx}" class="image-grid_alt editor-img_alt" type="text" ></label>
        </div>
      </li>`
    })

    this.wrapper.addEventListener('change', e => {
      const input = e.target,
        indexImg = input.dataset.image,
        images = Array.from(this.wrapper.querySelectorAll('.editor-img'))
      if (input.classList.contains('editor-img_alt')) {
        images[indexImg].setAttribute('alt', input.value)
      }
      this.api.saver.save()
    })
  }

  save (blockContent) {
    const image = Array.from(blockContent.querySelectorAll('.editor-img')),
      caption = Array.from(blockContent.querySelectorAll('.editor-img_caption'))

    return {
      url: image.map((img, idx) => {
        const url = img.src.substring(img.src.length, img.src.indexOf('/blogs/'))
        if (url) {
          return {
            url,
            alt: img.alt,
            cap: caption[idx].value || caption[idx].innerHTML || '',
          }
        }
      }),
    }
  }

  validate (savedData) {
    return savedData.url.length > 0
  }
}

export class ImageGrid extends ImageSlider {
  static get toolbox () {
    return {
      title: 'Сетка из картинок',
      icon:
        '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/grid/small" stroke="none" stroke-width="1"><path d="M6.5,8.75 C6.91421356,8.75 7.25,9.08578644 7.25,9.5 L7.25,9.5 L7.25,13.5 C7.25,13.9142136 6.91421356,14.25 6.5,14.25 L6.5,14.25 L2.5,14.25 C2.08578644,14.25 1.75,13.9142136 1.75,13.5 L1.75,13.5 L1.75,9.5 C1.75,9.08578644 2.08578644,8.75 2.5,8.75 L2.5,8.75 Z M13.5,8.75 C13.9142136,8.75 14.25,9.08578644 14.25,9.5 L14.25,9.5 L14.25,13.5 C14.25,13.9142136 13.9142136,14.25 13.5,14.25 L13.5,14.25 L9.5,14.25 C9.08578644,14.25 8.75,13.9142136 8.75,13.5 L8.75,13.5 L8.75,9.5 C8.75,9.08578644 9.08578644,8.75 9.5,8.75 L9.5,8.75 Z M5.75,10.25 L3.25,10.25 L3.25,12.75 L5.75,12.75 L5.75,10.25 Z M12.75,10.25 L10.25,10.25 L10.25,12.75 L12.75,12.75 L12.75,10.25 Z M13.5,1.75 C13.9142136,1.75 14.25,2.08578644 14.25,2.5 L14.25,2.5 L14.25,6.5 C14.25,6.91421356 13.9142136,7.25 13.5,7.25 L13.5,7.25 L9.5,7.25 C9.08578644,7.25 8.75,6.91421356 8.75,6.5 L8.75,6.5 L8.75,2.5 C8.75,2.08578644 9.08578644,1.75 9.5,1.75 L9.5,1.75 Z M6.5,1.75 C6.91421356,1.75 7.25,2.08578644 7.25,2.5 L7.25,2.5 L7.25,6.5 C7.25,6.91421356 6.91421356,7.25 6.5,7.25 L6.5,7.25 L2.5,7.25 C2.08578644,7.25 1.75,6.91421356 1.75,6.5 L1.75,6.5 L1.75,2.5 C1.75,2.08578644 2.08578644,1.75 2.5,1.75 L2.5,1.75 Z M12.75,3.25 L10.25,3.25 L10.25,5.75 L12.75,5.75 L12.75,3.25 Z M5.75,3.25 L3.25,3.25 L3.25,5.75 L5.75,5.75 L5.75,3.25 Z" id="grid"></path></g></svg>',
    }
  }

  constructor ({ data, api }) {
    super(data)
    this.data = data
    this.api = api
    this.wrapper = undefined
  }

  render () {
    this.wrapper = document.createElement('div')
    this.wrapper.classList.add('image-grid')

    if (this.data.url != null && this.data.url.length > 4) {
      this.wrapper = super.render()
      return this.wrapper
    }

    if (this.data.url != null && this.data.url.length) {
      const isEven = ((this.data.url.length / 2) % 1 === 0)
      this.wrapper.classList.add(isEven ? 'image-grid--double' : 'image-grid--triple')

      this.data.url.forEach(img => {
        this.wrapper.innerHTML +=
        `<div>
          <img src="/uploads${img.url}" alt=${img.alt} class="image-grid_img editor-img">
          <span class="editor-img_caption">${img.cap}</span>
        </div>`
      })
    } else {
      const buttonSubmit = createButton()
      const input = createInputFiles()

      this.wrapper.appendChild(input)
      this.wrapper.appendChild(buttonSubmit)

      buttonSubmit.addEventListener('click', e => {
        const payload = new FormData();

        Array.from(input.files).forEach(img => payload.append('pictures[]', img))

        fetch(editorConfig.imgUploadURL, {
          body: payload,
          method: 'POST'
        })
          .then(res => res.json())
          .then(res => {
            this.wrapper.querySelector('input[type="file"]').remove()
            this.wrapper.querySelector('button[type="button"]').remove()
            if (res.length < 5) {
              this._createImageGrid(res)
            } else {
              super._createSlider(res)
            }
          })
          .catch(console.error)
      })
    }

    return this.wrapper
  }

  _createImageGrid (url) {
    const isEven = ((url.length / 2) % 1 === 0)
    this.wrapper.classList.add(isEven ? 'image-grid--double' : 'image-grid--triple')

    url.forEach((img, idx) => {
      this.wrapper.innerHTML +=
      `
        <div class="image-grid_input-wrapper">
          <img data-image="${idx}" alt="image-${idx}" class="image-grid_img editor-img" src="/uploads${img.url}">
          <div class="form">
            <label>Комментарий<input data-image="${idx}" class="image-grid_caption-input editor-img_caption" type="text" ></label>
            <label>Alt<input data-image="${idx}" class="image-grid_alt editor-img_alt" type="text" ></label>
          </div>
        </div>
      `
    })

    this.wrapper.addEventListener('change', e => {
      const input = e.target,
        indexImg = input.dataset.image,
        images = Array.from(this.wrapper.querySelectorAll('.editor-img'))
      if (input.classList.contains('editor-img_alt')) {
        images[indexImg].setAttribute('alt', input.value)
      }
      this.api.saver.save()
    })
  }
}

export class Snippet {
  static get toolbox () {
    return {
      title: 'Скрытый текст',
      icon:
        '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/spoiler/small" stroke="none" stroke-width="1"><path d="M14,10.0000441 C14.4142136,10.0000441 14.75,10.3358306 14.75,10.7500441 C14.75,11.1297399 14.4678461,11.4435351 14.1017706,11.4931975 L14,11.5000441 L2,11.5000441 C1.58578644,11.5000441 1.25,11.1642577 1.25,10.7500441 C1.25,10.3703484 1.53215388,10.0565532 1.89822944,10.0068908 L2,10.0000441 L14,10.0000441 Z M11.5269968,5.21625969 L11.6,5.30004414 L12.5,6.50004414 L13.4,5.30004414 C13.6259347,4.99879791 14.0349874,4.91591 14.3564572,5.09005198 L14.45,5.15004414 C14.7512462,5.37597881 14.8341341,5.78503156 14.6599922,6.10650138 L14.6,6.20004414 L13.1,8.20004414 C12.8230769,8.56927491 12.2905325,8.59767727 11.9742831,8.28525124 L11.9,8.20004414 L10.4,6.20004414 C10.1514719,5.86867329 10.2186292,5.39857228 10.55,5.15004414 C10.8512462,4.92410947 11.2671455,4.95907184 11.5269968,5.21625969 Z M9,6.00004414 C9.41421356,6.00004414 9.75,6.33583058 9.75,6.75004414 C9.75,7.1297399 9.46784612,7.4435351 9.10177056,7.49319752 L9,7.50004414 L2,7.50004414 C1.58578644,7.50004414 1.25,7.1642577 1.25,6.75004414 C1.25,6.37034837 1.53215388,6.05655318 1.89822944,6.00689075 L2,6.00004414 L9,6.00004414 Z" id="spoiler"></path></g></svg>',
    }
  }

  static get enableLineBreaks () {
    return true
  }

  constructor ({ data }) {
    this.data = data
    this.wrapper = undefined
  }

  render () {
    this.wrapper = document.createElement('div')
    this.wrapper.classList.add('snippet')
    if (this.data.content != null) {
      this._createSnippet(this.data)
    } else {
      this.wrapper.innerHTML = `
        <label for="snippet-input" class="snippet_header">Заголовок для скрытого текста</label>
        <input id="snippet-input" type="text" class="snippet_input-text" />
        <label for="snippet-textarea" class="snippet_header">Содержимое скрытого текста</label>
        <textarea id="snippet-textarea" class="snippet_input"></textarea>
      `
      const button = createButton('snippet_button', { textContent: 'Сохранить' })
      this.wrapper.appendChild(button)

      button.addEventListener('click', e => {
        this._createSnippet()
      })
    }

    return this.wrapper
  }

  _createSnippet (data) {
    const title = data ? data.title : document.getElementById('snippet-input').value,
      content = data ? data.content : document.getElementById('snippet-textarea').value
    this.wrapper.innerHTML = `
      <span class="snippet_switcher">${title || 'Скрытый текст'}</span>
      <div class="snippet_content">${content}</div>
    `

    this.wrapper.addEventListener('click', function (event) {
      if (event.target.classList.contains('snippet_switcher')) {
        this.classList.toggle('snippet--active')
      }
    })
  }

  save (blockContent) {
    if (blockContent.querySelector('.snippet_content')) {
      const title = blockContent.querySelector('.snippet_switcher').innerHTML,
        content = blockContent.querySelector('.snippet_content').innerHTML
      return { title, content }
    }
  }

  validate (savedData) {
    return !!(savedData && savedData.content != null)
  }
}

export class Callout {
  static get toolbox () {
    return {
      title: 'Сноска',
      icon:
        '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/specialText/small" stroke="none" stroke-width="1"><path d="M3,1.75 C3.37969577,1.75 3.69349096,2.03215388 3.74315338,2.39822944 L3.75,2.5 L3.75,13.5 C3.75,13.9142136 3.41421356,14.25 3,14.25 C2.62030423,14.25 2.30650904,13.9678461 2.25684662,13.6017706 L2.25,13.5 L2.25,2.5 C2.25,2.08578644 2.58578644,1.75 3,1.75 Z M9,11.75 C9.41421356,11.75 9.75,12.0857864 9.75,12.5 C9.75,12.8796958 9.46784612,13.193491 9.10177056,13.2431534 L9,13.25 L6,13.25 C5.58578644,13.25 5.25,12.9142136 5.25,12.5 C5.25,12.1203042 5.53215388,11.806509 5.89822944,11.7568466 L6,11.75 L9,11.75 Z M11,8.75 C11.4142136,8.75 11.75,9.08578644 11.75,9.5 C11.75,9.87969577 11.4678461,10.193491 11.1017706,10.2431534 L11,10.25 L6,10.25 C5.58578644,10.25 5.25,9.91421356 5.25,9.5 C5.25,9.12030423 5.53215388,8.80650904 5.89822944,8.75684662 L6,8.75 L11,8.75 Z M9,5.75 C9.41421356,5.75 9.75,6.08578644 9.75,6.5 C9.75,6.87969577 9.46784612,7.19349096 9.10177056,7.24315338 L9,7.25 L6,7.25 C5.58578644,7.25 5.25,6.91421356 5.25,6.5 C5.25,6.12030423 5.53215388,5.80650904 5.89822944,5.75684662 L6,5.75 L9,5.75 Z M13,2.75 C13.4142136,2.75 13.75,3.08578644 13.75,3.5 C13.75,3.87969577 13.4678461,4.19349096 13.1017706,4.24315338 L13,4.25 L6,4.25 C5.58578644,4.25 5.25,3.91421356 5.25,3.5 C5.25,3.12030423 5.53215388,2.80650904 5.89822944,2.75684662 L6,2.75 L13,2.75 Z" id="specialText"></path></g></svg>',
    }
  }

  static get enableLineBreaks () {
    return true
  }

  constructor ({ data }) {
    this.data = data
    this.wrapper = undefined
  }

  render () {
    this.wrapper = document.createElement('div')

    if (this.data.type != null && this.data.text != null) {
      this.wrapper.classList.add('article-post__callout')
      switch (this.data.type) {
        case 'Внимание':
          this.wrapper.classList.add('article-post__callout--warning')
          break
        case 'На заметку':
          this.wrapper.classList.add('article-post__callout--toNote')
          break
        case 'Это интересно':
          this.wrapper.classList.add('article-post__callout--interesting')
          break
      }
      this._createCallout(this.data.text, this.data.type)
    } else {
      this.wrapper.classList.add('callout')
      const inputParagraph = document.createElement('textarea'),
        saveButton = createButton('callout_submit', { textContent: 'Сохранить' }),
        radioWrap =
              `
          <p>Заголовок сноски</p>
          <div class="radio-wrap">
            <input type="radio" value="warning" name="callout-type" id="radio_attention" checked>
            <label class="radio_label" for="radio_attention">Внимание</label>
            <input type="radio" value="toNote" name="callout-type" id="radio_notice">
            <label class="radio_label" for="radio_notice">На заметку</label>
            <input type="radio" value="interesting" name="callout-type" id="radio_interesting">
            <label class="radio_label" for="radio_interesting">Это интересно</label>
          </div>
        `
      inputParagraph.classList.add('callout_input', 'snippet_input')
      inputParagraph.setAttribute('placeholder', 'Введите текст сноски')

      this.wrapper.innerHTML = radioWrap
      this.wrapper.appendChild(inputParagraph)
      this.wrapper.appendChild(saveButton)

      saveButton.addEventListener('click', e => {
        if (!inputParagraph.value) {
          window.$toast('Введите текст для сноски и попробуйте сохранить снова.', { title: 'Ошибка... :(' })
          return
        }
        const radioButtons = document.querySelectorAll('input[name="callout-type"]'),
          checkedRadioButton = Array.from(radioButtons).find(el => el.checked)
        let textTitle
        switch (checkedRadioButton.value) {
          case 'warning':
            textTitle = 'Внимание'
            break
          case 'toNote':
            textTitle = 'На заметку'
            break
          case 'interesting':
            textTitle = 'Это интересно'
            break
        }
        this.wrapper.classList.add('article-post__callout', `article-post__callout--${checkedRadioButton.value}`, 'callout--mounted')
        this._createCallout(inputParagraph.value, textTitle)
      })
    }

    return this.wrapper
  }

  _createCallout (paragraphText, textTitle) {
    this.wrapper.innerHTML = `
      <h6 class="article-post__callout-title">${textTitle}</h6>
      <p class="article-post__callout-text">${paragraphText}</p>
    `
  }

  save (blockContent) {
    const title = blockContent.querySelector('.article-post__callout-title')
    const paragraph = blockContent.querySelector('.article-post__callout-text')

    if (title && paragraph) {
      return {
        type: title.innerHTML,
        text: paragraph.innerHTML,
      }
    }
  }

  validate (savedData) {
    return !!(savedData && savedData.type != null && savedData.text != null)
  }
}

export class Quote {
  static get toolbox () {
    return {
      title: 'Цитата',
      icon: '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/quote/small" stroke="none" stroke-width="1"><path d="M12.251,11.2645476 C12.6652136,11.2645476 13.001,11.600334 13.001,12.0145476 C13.001,12.3942434 12.7188461,12.7080385 12.3527706,12.757701 L12.251,12.7645476 L3.251,12.7645476 C2.83678644,12.7645476 2.501,12.4287611 2.501,12.0145476 C2.501,11.6348518 2.78315388,11.3210566 3.14922944,11.2713942 L3.251,11.2645476 L12.251,11.2645476 Z M5.51258282,3.27063645 C6.49687254,3.80867559 7.02318963,5.04248531 6.99995041,7.02317245 C6.98661977,8.18230052 6.4476886,8.99226018 5.59020962,9.42854655 C5.09099681,9.68254665 4.60770466,9.76454758 4.25003794,9.76454758 C3.83582437,9.76454758 3.50002095,9.42879908 3.5,9.01458552 C3.4999808,8.63488976 3.7821188,8.32108029 4.14819185,8.27139935 L4.24996206,8.26454759 C4.3923459,8.26454038 4.6591296,8.21928476 4.90999263,8.09164534 C5.28522145,7.90072845 5.49335626,7.58792264 5.50005162,7.00574852 C5.50182247,6.85481776 5.50026601,6.71190779 5.4955947,6.57670803 C5.15457979,6.85159172 4.72139908,7.01454758 4.25,7.01454758 C3.146,7.01454758 2.25,6.11914758 2.25,5.01454758 C2.25,3.93605631 3.10414421,3.05699246 4.17207406,3.01603924 L4.02816993,3.03938976 C4.49671808,2.95389301 5.01283333,2.99745998 5.51258282,3.27063645 Z M11.5125828,3.27063645 C12.4968725,3.80867559 13.0231896,5.04248531 12.9999504,7.02317245 C12.9866198,8.18230052 12.4476886,8.99226018 11.5902096,9.42854655 C11.0909968,9.68254665 10.6077047,9.76454758 10.2500379,9.76454758 C9.83582437,9.76454758 9.50002095,9.42879908 9.5,9.01458552 C9.4999808,8.63488976 9.7821188,8.32108029 10.1481919,8.27139935 L10.2499621,8.26454759 C10.3923459,8.26454038 10.6591296,8.21928476 10.9099926,8.09164534 C11.2852215,7.90072845 11.4933563,7.58792264 11.5000516,7.00574852 C11.5018225,6.85481776 11.500266,6.71190779 11.4955947,6.57670803 C11.1545798,6.85159172 10.7213991,7.01454758 10.25,7.01454758 C9.146,7.01454758 8.25,6.11914758 8.25,5.01454758 C8.25,3.93605631 9.10414421,3.05699246 10.1720741,3.01603924 L10.0281699,3.03938976 C10.4967181,2.95389301 11.0128333,2.99745998 11.5125828,3.27063645 Z" id="quote"></path></g></svg>',
    }
  }

  static get enableLineBreaks () {
    return true
  }

  constructor ({ data }) {
    this.data = data
    this.wrapper = undefined
  }

  render () {
    this.wrapper = document.createElement('div')

    const quoteWrapper = document.createElement('div')
    const quoteParagraph = 'Введите текст цитаты'
    const quoteTitle = 'Введите имя автора'
    const quoteSubtitle = 'Введите должность автора'

    quoteWrapper.classList.add('quote', 'article-post__blockquote')
    quoteWrapper.innerHTML = `
        <blockquote class="quote_paragraph" contenteditable="true">${this.data.text || quoteParagraph}</blockquote>
        <cite class="quote_title" style="padding-right: 10px;" contenteditable="true">${this.data.author || quoteTitle}</cite>
        <span class="quote_subtitle" style="padding-right: 10px;" contenteditable="true">${this.data.position || quoteSubtitle}</span>
      `

    this.wrapper.appendChild(quoteWrapper)

    if (!Object.keys(this.data).length) {
      quoteWrapper.addEventListener('click', event => {
        const isDefaultString = [quoteParagraph, quoteTitle, quoteSubtitle].includes(event.target.innerHTML)

        if (event.target !== quoteWrapper && isDefaultString) {
          event.target.innerHTML = ''
        }
      })
    }

    return this.wrapper
  }

  save (blockContent) {
    const inputParagraph = blockContent.querySelector('.quote_paragraph'),
      inputAuthor = blockContent.querySelector('.quote_title'),
      inputJob = blockContent.querySelector('.quote_subtitle')
    if (inputParagraph && inputAuthor && inputJob) {
      return {
        text: inputParagraph.innerHTML,
        author: inputAuthor.innerHTML,
        position: inputJob.innerHTML,
      }
    }
  }

  validate (savedData) {
    return !!(savedData && savedData.text && savedData.author && savedData.position)
  }
}

export class UpsideIndex {
  static get title () {
    return 'Верхний индекс'
  }

  static get isInline () {
    return true
  }

  static get sanitize () {
    return {
      sup: {
        class: 'supIndex',
      },
    }
  }

  get state () {
    return this._state
  }

  set state (state) {
    this._state = state

    this.button.classList.toggle(this.api.styles.inlineToolButtonActive, state)
  }

  constructor ({ api }) {
    this.api = api
    this.button = null
    this._state = false

    this.tag = 'sup'
    this.class = 'supIndex'
  }

  render () {
    this.button = document.createElement('button')
    this.button.type = 'button'
    this.button.innerHTML =
      '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/upside/small" stroke="none" stroke-width="1"><path d="M8.38598516,2.35699365 C8.7115716,2.55234551 8.83548178,2.95573677 8.68972264,3.29519507 L8.64323304,3.38598516 L5.874,8 L8.64323304,12.6142415 C8.85634416,12.9694267 8.74117036,13.4301219 8.38598516,13.643233 C8.06039873,13.8385849 7.6461546,13.7580862 7.4152251,13.4697301 L7.35699365,13.3859852 L5,9.458 L2.64323304,13.3859852 C2.43012192,13.7411704 1.96942673,13.8563442 1.61424153,13.643233 C1.2886551,13.4478812 1.16474491,13.0444899 1.31050406,12.7050316 L1.35699365,12.6142415 L4.125,8 L1.35699365,3.38598516 C1.14388253,3.03079996 1.25905633,2.57010477 1.61424153,2.35699365 C1.93982796,2.16164179 2.3540721,2.24214045 2.5850016,2.53049655 L2.64323304,2.61424153 L5,6.542 L7.35699365,2.61424153 C7.57010477,2.25905633 8.03079996,2.14388253 8.38598516,2.35699365 Z M14.0001133,2.25011335 C14.4143269,2.25011335 14.7501133,2.58589978 14.7501133,3.00011335 C14.7501133,3.37980911 14.4679595,3.69360431 14.1018839,3.74326673 L14.0001133,3.75011335 L12.75,3.75 L12.7501133,7.00011335 C12.7501133,7.41432691 12.4143269,7.75011335 12.0001133,7.75011335 C11.6204176,7.75011335 11.3066224,7.46795946 11.25696,7.1018839 L11.2501133,7.00011335 L11.25,3.75 L10.0001133,3.75011335 C9.58589978,3.75011335 9.25011335,3.41432691 9.25011335,3.00011335 C9.25011335,2.62041758 9.53226723,2.30662239 9.89834279,2.25695996 L10.0001133,2.25011335 L14.0001133,2.25011335 Z" id="upside"></path></g></svg>'
    this.button.classList.add(this.api.styles.inlineToolButton)

    return this.button
  }

  surround (range) {
    if (this.state) {
      this.unwrap(range)
      return
    }

    this.wrap(range)
  }

  wrap (range) {
    const selectedText = range.extractContents()
    const mark = document.createElement(this.tag)

    mark.classList.add(this.class)
    mark.appendChild(selectedText)
    range.insertNode(mark)

    this.api.selection.expandToTag(mark)
  }

  unwrap (range) {
    const mark = this.api.selection.findParentTag(this.tag, this.class)
    const text = range.extractContents()

    mark.remove()

    range.insertNode(text)
  }

  checkState () {
    const mark = this.api.selection.findParentTag(this.tag)

    this.state = !!mark
  }
}

export class DownIndex {
  static get title () {
    return 'Нижний индекс'
  }

  static get isInline () {
    return true
  }

  static get sanitize () {
    return {
      sub: {
        class: 'subIndex',
      },
    }
  }

  get state () {
    return this._state
  }

  set state (state) {
    this._state = state

    this.button.classList.toggle(this.api.styles.inlineToolButtonActive, state)
  }

  constructor ({ api }) {
    this.api = api
    this.button = null
    this._state = false

    this.tag = 'sub'
    this.class = 'subIndex'
  }

  render () {
    this.button = document.createElement('button')
    this.button.type = 'button'
    this.button.innerHTML =
      '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/downside/small" stroke="none" stroke-width="1"><path d="M8.38598516,2.35699365 C8.7115716,2.55234551 8.83548178,2.95573677 8.68972264,3.29519507 L8.64323304,3.38598516 L5.874,8 L8.64323304,12.6142415 C8.85634416,12.9694267 8.74117036,13.4301219 8.38598516,13.643233 C8.06039873,13.8385849 7.6461546,13.7580862 7.4152251,13.4697301 L7.35699365,13.3859852 L5,9.458 L2.64323304,13.3859852 C2.43012192,13.7411704 1.96942673,13.8563442 1.61424153,13.643233 C1.2886551,13.4478812 1.16474491,13.0444899 1.31050406,12.7050316 L1.35699365,12.6142415 L4.125,8 L1.35699365,3.38598516 C1.14388253,3.03079996 1.25905633,2.57010477 1.61424153,2.35699365 C1.93982796,2.16164179 2.3540721,2.24214045 2.5850016,2.53049655 L2.64323304,2.61424153 L5,6.542 L7.35699365,2.61424153 C7.57010477,2.25905633 8.03079996,2.14388253 8.38598516,2.35699365 Z M14.0001133,8.25011335 C14.4143269,8.25011335 14.7501133,8.58589978 14.7501133,9.00011335 C14.7501133,9.37980911 14.4679595,9.69360431 14.1018839,9.74326673 L14.0001133,9.75011335 L12.75,9.75 L12.7501133,13.0001133 C12.7501133,13.4143269 12.4143269,13.7501133 12.0001133,13.7501133 C11.6204176,13.7501133 11.3066224,13.4679595 11.25696,13.1018839 L11.2501133,13.0001133 L11.25,9.75 L10.0001133,9.75011335 C9.58589978,9.75011335 9.25011335,9.41432691 9.25011335,9.00011335 C9.25011335,8.62041758 9.53226723,8.30662239 9.89834279,8.25695996 L10.0001133,8.25011335 L14.0001133,8.25011335 Z" id="downside"></path></g></svg>'
    this.button.classList.add(this.api.styles.inlineToolButton)

    return this.button
  }

  surround (range) {
    if (this.state) {
      this.unwrap(range)
      return
    }

    this.wrap(range)
  }

  wrap (range) {
    const selectedText = range.extractContents()
    const mark = document.createElement(this.tag)

    mark.classList.add(this.class)
    mark.appendChild(selectedText)
    range.insertNode(mark)

    this.api.selection.expandToTag(mark)
  }

  unwrap (range) {
    const mark = this.api.selection.findParentTag(this.tag, this.class)
    const text = range.extractContents()

    mark.remove()

    range.insertNode(text)
  }

  checkState () {
    const mark = this.api.selection.findParentTag(this.tag)

    this.state = !!mark
  }

}

export class Colorizer {
  static get title () {
    return 'Цвет текста'
  }

  static get isInline () {
    return true
  }

  static get sanitize () {
    return {
      mark: true,
    }
  }

  get shortcut () {
    return 'ALT+C'
  }

  get state () {
    return this._state
  }

  set state (state) {
    this._state = state

    this.button.classList.toggle(this.api.styles.inlineToolButtonActive, state)
  }

  constructor ({ api }) {
    this.api = api
    this.button = null
    this._state = false

    this.tag = 'MARK'
    this.class = 'colorizer'
  }

  render () {
    this.button = document.createElement('button')
    this.button.type = 'button'
    this.button.innerHTML = '<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="icon/color/small" stroke="none" stroke-width="1"><path d="M13.000417,13.25 C13.4146305,13.25 13.750417,13.5857864 13.750417,14 C13.750417,14.3796958 13.4682631,14.693491 13.1021875,14.7431534 L13.000417,14.75 L3.00041697,14.75 C2.58620341,14.75 2.25041697,14.4142136 2.25041697,14 C2.25041697,13.6203042 2.53257085,13.306509 2.89864642,13.2568466 L3.00041697,13.25 L13.000417,13.25 Z M8.83408689,1.46966991 C9.12698011,1.1767767 9.60185384,1.1767767 9.89474706,1.46966991 L9.89474706,1.46966991 L12.7231471,4.29806991 C13.0160403,4.59096313 13.0160403,5.06583687 12.7231471,5.35873009 L12.7231471,5.35873009 L7.06624706,11.0156301 C7.03950905,11.0423681 7.01090265,11.0669322 6.98070774,11.0891725 L7.06624706,11.0156301 C7.02201292,11.0598642 6.97362807,11.0974179 6.92234624,11.1282912 C6.90968266,11.1357071 6.89645406,11.143132 6.88301163,11.1501498 C6.86559266,11.1594678 6.84806009,11.1677571 6.83029472,11.1753293 C6.78318851,11.1952233 6.73382174,11.210572 6.68300407,11.2207355 L6.77420038,11.1966146 C6.75598931,11.2026995 6.73759108,11.2080665 6.71904984,11.2127157 L6.68300407,11.2207355 L3.14750407,11.9278355 C2.62271322,12.0327937 2.1600233,11.5701038 2.26498147,11.0453129 L2.26498147,11.0453129 L2.97208147,7.5098129 L2.97208147,7.5098129 C3.00290332,7.3636467 3.07068026,7.23307654 3.17718689,7.12656991 Z M4.167,9.177 L3.95641697,10.235 L5.013,10.023 L4.167,9.177 Z M9.36441697,3.06 L4.768,7.656 L6.535,9.423 L11.132417,4.828 L9.36441697,3.06 Z" id="color"></path></g></svg>'
    this.button.classList.add(this.api.styles.inlineToolButton)

    return this.button
  }

  surround (range) {
    if (this.state) {
      this.unwrap(range)
      return
    }

    this.wrap(range)
  }

  wrap (range) {
    const selectedText = range.extractContents()
    const mark = document.createElement(this.tag)

    mark.classList.add(this.class)
    mark.appendChild(selectedText)
    range.insertNode(mark)

    this.api.selection.expandToTag(mark)
  }

  unwrap (range) {
    const mark = this.api.selection.findParentTag(this.tag, this.class)
    const text = range.extractContents()

    mark.remove()

    range.insertNode(text)
  }

  checkState () {
    const mark = this.api.selection.findParentTag(this.tag)

    this.state = !!mark

    if (this.state) {
      this.showActions(mark)
    } else {
      this.hideActions()
    }
  }

  renderActions () {
    this.colorPicker = document.createElement('div')
    this.colorPicker.setAttribute('style', 'display: flex; align-items: center;')
    const inputColorizer = document.createElement('input')
    const span = document.createElement('span')
    span.innerHTML = 'Выбрать цвет:'
    inputColorizer.type = 'color'
    inputColorizer.value = '#f5f1cc'
    inputColorizer.setAttribute('style', 'margin-left: 8px;')
    inputColorizer.setAttribute('class', 'inputColorizer')
    this.colorPicker.appendChild(span)
    this.colorPicker.appendChild(inputColorizer)
    this.colorPicker.hidden = true

    return this.colorPicker
  }

  showActions (mark) {
    const { color } = mark.style
    const inputColorizer = document.querySelector('.inputColorizer')
    inputColorizer.value = color ? this.convertToHex(color) : '#f5f1cc'

    inputColorizer.onchange = () => {
      mark.style.color = inputColorizer.value
    }
    this.colorPicker.hidden = false
  }

  hideActions () {
    this.colorPicker.onchange = null
    this.colorPicker.hidden = true
  }

  convertToHex (color) {
    const rgb = color.match(/(\d+)/g)

    let hexr = parseInt(rgb[0]).toString(16)
    let hexg = parseInt(rgb[1]).toString(16)
    let hexb = parseInt(rgb[2]).toString(16)

    hexr = hexr.length === 1 ? '0' + hexr : hexr
    hexg = hexg.length === 1 ? '0' + hexg : hexg
    hexb = hexb.length === 1 ? '0' + hexb : hexb

    return '#' + hexr + hexg + hexb
  }
}
